import { render, staticRenderFns } from "./LProjectConfigurationShare.vue?vue&type=template&id=570a20f8&scoped=true&"
import script from "./LProjectConfigurationShare.vue?vue&type=script&lang=js&"
export * from "./LProjectConfigurationShare.vue?vue&type=script&lang=js&"
import style0 from "./LProjectConfigurationShare.vue?vue&type=style&index=0&id=570a20f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570a20f8",
  null
  
)

export default component.exports